<template>
  <div>
    <v-btn
      class="rounded-xl white--text"
      color="primaryAction"
      @click="$refs[uploadRef].click()"
      >{{ buttonText }}</v-btn
    >
    <input
      v-show="false"
      :ref="uploadRef"
      hidden
      type="file"
      :accept="formats"
      @change="onFileUpload($event, jwt)"
    />
  </div>
</template>
<script>
import hasMediaObjectUpload from "@/mixins/hasMediaObjectUpload";
export default {
  mixins: [hasMediaObjectUpload],
  props: {
    addText: String,
    changeText: String,
  },
  computed: {
    buttonText() {
      if (this.url != "") {
        return this.changeText;
      }
      return this.addText;
    },
  },
}
</script>